import styled from '@emotion/styled';

export const TabWithdrawalsWrapper = styled('section', { label: 'TabWithdrawalsWrapper' })`
    margin-top: 20px;
`;

export const NoItemInfo = styled('div', { label: 'NoItemInfo' })`
`;
